/**
 * Dropdown lists for /cake-request.
 * Tammy edits these in Admin → Product Options (category Custom Cakes).
 * Groups whose names contain Size, Flavour/Flavor, or Filling are used.
 */

export const CAKE_REQUEST_PATH = '/cake-request';
export const CAKE_REQUEST_PRINT_PATH = '/cake-request/print';
export const CAKE_REQUEST_CATEGORY = 'Custom Cakes';

export const FALLBACK_CAKE_SIZES = [
  '6" (8-10 servings)',
  '8" (12-16 servings)',
  '10" (20-24 servings)',
  'Sheet (24-30 servings)',
  'Cupcakes (12)',
];

export const FALLBACK_CAKE_FLAVOURS = [
  'Vanilla',
  'Chocolate',
  'Red Velvet',
  'Marble',
  'Lemon',
  'Carrot',
  'Funfetti',
  'Other',
];

export const FALLBACK_CAKE_FILLINGS = [
  'Buttercream',
  'Cream Cheese',
  'Chocolate Ganache',
  'Strawberry',
  'Raspberry',
  'Lemon Curd',
  'None',
  'Other',
];

export const DEFAULT_CAKE_REQUEST_NOTICE =
  '72 hours notice required on all custom cake orders.';

type OptionGroup = {
  name?: string;
  options?: Array<{ name?: string; is_available?: boolean }>;
};

function optionNames(group: OptionGroup | undefined): string[] {
  return (group?.options || [])
    .map((opt) => opt.name)
    .filter((name): name is string => Boolean(name));
}

function pickGroup(groups: OptionGroup[], pattern: RegExp): OptionGroup | undefined {
  return groups.find((group) => pattern.test(group.name || ''));
}

/** Map product-option groups to the three cake-request dropdowns. */
export function cakeRequestDropdowns(groups: OptionGroup[]) {
  const sizes = optionNames(pickGroup(groups, /size/i));
  const flavours = optionNames(pickGroup(groups, /flavou?r/i));
  const fillings = optionNames(pickGroup(groups, /filling/i));
  return {
    sizes: sizes.length ? sizes : FALLBACK_CAKE_SIZES,
    flavours: flavours.length ? flavours : FALLBACK_CAKE_FLAVOURS,
    fillings: fillings.length ? fillings : FALLBACK_CAKE_FILLINGS,
  };
}
